<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="isCreated ? '新增' : '编辑'"
    :visible.sync="show"
    width="750px"
    class="add-account"
    v-loading="loading"
  >
    <el-form
      size="small"
      :model="params"
      ref="form"
      label-width="80px"
      :rules="rules"
    >
      <el-form-item label="模版名称" prop="name">
        <el-input
          v-model="params.name"
          clearable
          placeholder="请输入"
          maxlength="10"
        ></el-input>
      </el-form-item>

      <el-form-item prop="image" label="图片">
        <CuttingUpload v-model="params.image" :fileSize="1024 * 1024 * 5" />
      </el-form-item>

      <el-form-item prop="attachment" label="附件">
        <UploadFile
          ref="UploadFile2"
          v-model="params.attachmentList"
          :showAccept="false"
          :preAppendixAddr="params && params.attachment"
          :limitFileNameLength="0"
        />
      </el-form-item>
      <el-form-item prop="description" label="故障描述">
        <el-input
          v-model="params.description"
          type="textarea"
          maxlength="500"
          show-word-limit
          placeholder="请输入备注"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确定</el-button>
      <el-button @click="show = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import dialogCommonParams from '@/mixins/dialogCommonParams'

export default {
  mixins: [dialogCommonParams],
  components: {},
  data() {
    const rules = {
      name: [{ required: true, message: '请输入项目名称' }],
      description: [{ required: true, message: '请输入故障描述' }]
    }

    return {
      loading: false,
      rules,
      params: {}
    }
  },
  created() {
    if (!this.isCreated) {
      this.params = { ...this.currentItem }
    }
  },

  methods: {
    async submitForm() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          try {
            this.loading = true
            let params = this.$utils.deepClone(this.params)
            if (params.attachmentList?.length > 0) {
              params.attachment = params.attachmentList[0].url
              params.fileName = params.attachmentList[0].name
              delete params.attachmentList
            }
            if (this.isCreated) {
              await this.$api.workOrder.addTemplate(params)
            } else {
              await this.$api.workOrder.editTemplate(params)
            }

            this.$message.success('操作成功')
            this.$emit('updateList')
            this.show = false
          } catch (err) {
            console.log(err)
          } finally {
            this.loading = false
          }
        }
      })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped></style>
